'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _css = require('antd/lib/table/style/css');

var _table = require('antd/lib/table');

var _table2 = _interopRequireDefault(_table);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _constants = require('../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CouponList = _react2.default.createClass({
    displayName: 'CouponList',

    propTypes: {
        coupons: _react.PropTypes.object.isRequired
    },
    render: function render() {
        var _this = this;

        var columns = [{
            title: '优惠券编号',
            key: 'coupon_id',
            dataIndex: 'coupon_id'
        }, {
            title: '用户编号',
            key: 'user_id',
            dataIndex: 'user_id'
        }, {
            title: '名称',
            key: 'title',
            render: function render(text, record, index) {
                return _react2.default.createElement(
                    'span',
                    null,
                    record.title,
                    ' \u2014\u2014 ',
                    record.sub_title
                );
            }
        }, {
            title: '状态',
            key: 'status_info',
            dataIndex: 'status_info'
        }, {
            title: '起止时间',
            key: 'time',
            render: function render(text, record, index) {
                return _react2.default.createElement(
                    'span',
                    null,
                    new Date(record.begin * 1000).toLocaleString(),
                    ' ~ ',
                    new Date(record.end * 1000).toLocaleString()
                );
            }
        }, {
            title: '最低消费',
            key: 'require_fee',
            dataIndex: 'require_fee'
        }, {
            title: '面值',
            key: 'discount_fee',
            dataIndex: 'discount_fee'
        }];
        var coupons = this.props.coupons;
        var items = coupons.items,
            error = coupons.error,
            pagination = coupons.pagination,
            isFetching = coupons.isFetching;

        var pager = Object.assign(_constants.PaginationConfig, {
            total: pagination.total,
            current: pagination.current_page,
            pageSize: pagination.per_page,
            onChange: function onChange(page, pageSize) {
                // 页码改变的回调，参数是改变后的页码及每页条数
                _this.props.onChange(page);
            },
            onShowSizeChange: function onShowSizeChange(current, pageSize) {

            }
        });
        var tableConfig = {
            columns: columns,
            locale: { emptyText: error && !error.ok ? '\u7F51\u7EDC\u9519\u8BEF\uFF1A' + error.statusText : '暂无数据' },
            dataSource: items,
            loading: isFetching,
            // pagination: pager,
            rowKey: function rowKey(record) {
                return record.coupon_id;
            }
        };
        return _react2.default.createElement(_table2.default, tableConfig);
    }
});

exports.default = CouponList;


//////////////////
// WEBPACK FOOTER
// ./src/js/components/coupon_list.js
// module id = 1570
// module chunks = 0